// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// Verion : 0.0.2
// LastEdit : AGALYA
// Last ADD : ADDED COMMENTS
// MODFIED DATA : 28-02-2026

import AccuredInterestReportTypes from './accured-interest-report.types';

/** ***************** FETCH AccuredInterest DETAILS START *********************** */
export const fetchAccuredInterestReportStart = (addData: any) => ({
	type: AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_START,
	payload: addData,
});

export const fetchAccuredInterestReportSuccess = (successData: any) => ({
	type: AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_SUCCESS,
	payload: successData,
});

export const fetchAccuredInterestReportFailure = (failureData: any) => ({
	type: AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_FAILURE,
	payload: failureData,
});

export const fetchAccuredInterestReportResponseResetStart = () => ({
	type: AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_RESPONSE_RESET_START,
});

export const fetchAccuredInterestReportResponseResetChanged = () => ({
	type: AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_RESPONSE_CHANGED,
});

/** ***************** FETCH AccuredInterest DETAILS END *********************** */
